import { Controller } from "@hotwired/stimulus"

const ROW_SELECTOR = ".js-cat-row"

export default class extends Controller {
  static targets = ["input"]

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()

    if (!query) {
      this.reset()
      return
    }

    this.rootRows.forEach((row) => this.applyFilter(row, query))
  }

  reset() {
    this.element.querySelectorAll(ROW_SELECTOR).forEach((row) => {
      row.style.display = ""
      const kids = row.querySelector(":scope > [id^='sf-cat-']")
      if (kids) kids.style.display = ""
    })
  }

  get rootRows() {
    return Array.from(this.element.querySelectorAll(ROW_SELECTOR)).filter(
      (row) => !row.parentElement.closest(ROW_SELECTOR)
    )
  }

  applyFilter(row, query) {
    const label = row.querySelector(":scope > .flex a")?.textContent.trim().toLowerCase() || ""
    const kids = row.querySelector(":scope > [id^='sf-cat-']")

    let childMatch = false
    if (kids) {
      kids.querySelectorAll(":scope > " + ROW_SELECTOR).forEach((childRow) => {
        if (this.applyFilter(childRow, query)) childMatch = true
      })
    }

    const visible = label.includes(query) || childMatch

    row.style.display = visible ? "" : "none"
    if (kids) kids.style.display = visible ? "block" : ""

    return visible
  }
}
